import baseConfig from './baseConfig'
import {serverCsaveExtensions} from './csaveConfigs'
// eslint-disable-next-line import/no-unresolved
import appComponentVersionsConfig from '@wix/dm-fragment-configs/configs/appComponentVersionsConfig.json'

const modulesList: string[] = []

const extensionsList: string[] = [
    ...baseConfig.extensionsList,
    ...serverCsaveExtensions,
    'seo',
    'advancedSeo',
    'localEditor',
    'componentsByType',
    'measurements',
    'layoutSettings',
    'mobileAlgo'
]

export default {
    ...baseConfig,
    modulesList,
    extensionsList,
    supportedFragments: {
        ...baseConfig.supportedFragments,
        AppComponentVersions: Object.assign(appComponentVersionsConfig.defaultConfigurations, {
            loadOnInit: false
        })
    },
    isReadOnly: false,
    noUndo: false,
    runStylesGC: false,
    supportMobile: true,
    postUpdateOperation: true,
    disableCommonConfig: true,
    continuousSave: true,
    dontCollectFixerVersionData: true,
    disableCSaveValidationOnInitialization: true,
    keepMultiLingualModelsFromServer: true,
    disablePublishPipeline: true,
    withoutViewer: true,
    skipBuilderSchemaValidation: true
}
